module.exports = __webpack_public_path__ + "static/img/11.603a514.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/11.png
// module id = gWff
// module chunks = 0